import { ChallengeWithUser } from '../models';
import { ChallengeRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetChallengesSentUseCase {
  constructor(private challengeRepository: ChallengeRepository) {}

  async execute(userId: string, limit?: number, offset?: number): Promise<ChallengeWithUser[]> {
    logger.debug('GetChallengesSent', 'Fetching challenges sent', { userId, limit, offset });

    const challenges = await this.challengeRepository.getChallengesSent(userId, limit, offset);

    logger.debug('GetChallengesSent', 'Challenges sent fetched', { count: challenges.length });

    return challenges;
  }
}
